import { logger } from '../utils/log'
import type { MessageCallback } from '../message/IMessageClient'
import { messageClient } from '../message/WebsocketMessageClient'
import type { ResponseHandler, BasicResponse } from './Model'
import { sendMessage } from '../message/api'

/**
 * 请求管理器
 */
class RequestManager implements MessageCallback {
  options: RequestOptions | null = null
  mqttClientId: string | null = null
  dataArriveListener: DataArriveListener[] = []
  wsInitTime = 0

  init(options: RequestOptions) {
    this.options = options
    this.initMessageClient(this.options)
    this.wsInitTime = new Date().getTime()
    messageClient.registerCallback(this as MessageCallback)
  }

  initMessageClient(options: RequestOptions) {
    messageClient.init({
      wsAddress: options.wsAddress,
      retries: options.retries,
      apiAddress: options.apiAddress,
    })
  }

  request<T extends BasicResponse>(request: any, responseHandler: ResponseHandler<T>): void {
    logger.log(`Request to ${request.url}`)

    /* 检测ws是否是正常连接状态 */
    if (!messageClient.hasConnected) {
      /* 避免接口调用多次初始化 */
      const nowTime = new Date().getTime()

      if (nowTime - this.wsInitTime > 5000) {
        this.initMessageClient(this.options as RequestOptions)
        this.wsInitTime = nowTime
      }
      setTimeout(() => {
        this.postMessage<T>(request, responseHandler)
      }, 1000)
    } else {
      this.postMessage<T>(request, responseHandler)
    }
  }

  postMessage<T extends BasicResponse>(request: any, responseHandler: ResponseHandler<T>) {
    const { url, topic, ...restRequest } = request

    // 调用请求接口
    sendMessage<T>(restRequest, url)
      .then((res: T) => {
        if (res.code == 0) {
          console.log(res, '增加消息成功')
          responseHandler.onSuccess(topic, request, res)
        } else {
          responseHandler.onError(topic, request, res)
        }
      })
      .catch((error) => {
        responseHandler.onError(topic, request, error)
      })
  }

  close() {
    messageClient.close()
  }

  addOnDataArrivedListener(listener: DataArriveListener) {
    if (this.dataArriveListener.indexOf(listener) < 0) {
      this.dataArriveListener.push(listener)
    }
  }

  removeOnDataArrivedListener(listener: DataArriveListener) {
    if (this.dataArriveListener.indexOf(listener) >= 0) {
      this.dataArriveListener.splice(this.dataArriveListener.indexOf(listener), 1)
    }
  }

  clearOnDataArrivedListener() {
    this.dataArriveListener = []
  }

  // MessageClient 回调 START
  onConnectionLost(cause: any | null) {
    return
  }

  onMessageArrived(responseStr: string | undefined) {
    logger.log('Message Arrived for client')

    for (const listener of this.dataArriveListener) {
      listener.onDataArrived(responseStr)
    }
  }
}

export interface DataArriveListener {
  onDataArrived(resp: string | undefined): void
}

export interface RequestOptions {
  wsAddress: string
  apiAddress: string
  retries: number //重试次数
}

export const requestManager = new RequestManager()
